import React, { useState } from "react";
import "../Styles/login.css";

const AdminLogin = () => {
  // "login" = Login page, "forgot" = Forgot Password page
  const [view, setView] = useState("login");

  const [loginData, setLoginData] = useState({
    email: "",
    password: "",
  });

  const [forgotEmail, setForgotEmail] = useState("");

  const [showPassword, setShowPassword] = useState(false);

  const handleLoginChange = (e) => {
    const { name, value } = e.target;
    setLoginData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleLoginSubmit = (e) => {
    e.preventDefault();
    console.log("Login submitted:", loginData);
    // TODO: Add your login API here
  };

  const handleForgotSubmit = (e) => {
    e.preventDefault();
    console.log("Reset link requested for:", forgotEmail);
    // TODO: Add your forgot password API here
  };

  return (
    <div className="adminlogin-container">
      {/* ---------------- LEFT SIDE ---------------- */}
      <div className="adminlogin-left">
       <div className="adminlogin-logo">
          <img
            src="/OS_logo_db.png"
            alt="Outstanding Logo"
            className="adminlogin-logo-img"
          />
        </div>

       <div className="adminlogin-illustration">
        <img src="/OS_img.png" alt="Outstanding" />
      </div>
        <div className="adminlogin-left-bottom">
          <h2>Welcome Back!</h2>
          <p>Sign in to your Customer account</p>
        </div>
      </div>

      {/* ---------------- RIGHT SIDE ---------------- */}
      <div className="adminlogin-right">
        {view === "login" ? (
          <form className="adminlogin-form" onSubmit={handleLoginSubmit}>
            <h1 className="adminform-heading">Admin Login</h1>

            <p className="adminform-subheading">
              Enter your credentials to access the admin dashboard
            </p>

            <label className="adminform-label">User Email ID</label>

            <input
              type="email"
              name="email"
              className="adminform-input"
              placeholder="Enter your Email ID"
              value={loginData.email}
              onChange={handleLoginChange}
              required
            />

            <label className="adminform-label">Password</label>

            <div className="adminpassword-field">
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                className="adminform-input"
                placeholder="Enter your Password"
                value={loginData.password}
                onChange={handleLoginChange}
                required
              />
             <img
              src="/Admin_log_eye.png"
              alt="Toggle password visibility"
              className="adminpassword-eye-icon"
              onClick={() => setShowPassword((prev) => !prev)}
            />
            </div>

            <button
              type="button"
              className="adminlink-btn adminforgot-link"
              onClick={() => setView("forgot")}
            >
              Forgot Password?
            </button>

            <button type="submit" className="adminprimary-btn">
              SIGN IN
            </button>
          </form>
        ) : (
          <form className="adminlogin-form" onSubmit={handleForgotSubmit}>
            <h1 className="adminform-heading">Forgot Password?</h1>

            <p className="adminform-subheading">
              Enter your username and we'll send a reset link to the registered
              email.
            </p>

            <label className="adminform-label">User Email ID</label>

            <input
              type="email"
              name="forgotEmail"
              className="adminform-input"
              placeholder="Enter your Email ID"
              value={forgotEmail}
              onChange={(e) => setForgotEmail(e.target.value)}
              required
            />

            <button
              type="button"
              className="adminlink-btn adminback-link"
              onClick={() => setView("login")}
            >
              <div className="adminback-link-content">
                        <img
              src="/Admin_log-arrow.png"
              alt="Back"
              className="adminback-arrow"
            />
            <span>Back to Login</span>
            </div>
            </button>

            <button type="submit" className="adminprimary-btn">
              Send Reset Link
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default AdminLogin;